export default "__VITE_ASSET__CdVjXU7R__"